import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { X, ArrowLeft } from "lucide-react";
import Loader from "../components/Common/Loader";
import NoDataImg from "../images/notdata.png";
import { APIUtility, APIEND_POINT } from "../Api";
import RemarkIcon from "../images/svg/RemarkIcon.svg";
import RemarkAddedIcon from "../images/svg/RemarkAddedIcon.svg";
import ImageWithRect from "../components/Common/ImageWithRect";
import { addToast } from "../Redux/CommonSlice/toastSlice";
import { useDispatch } from "react-redux";

const ViewImageModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [ImageDetails, setImageDetails] = useState(null);

  const { show, onHide, qrcodeId } = props;

  useEffect(() => {
    if (show) {
      fetchImageDetails();
    }
  }, [show]);

  const fetchImageDetails = async () => {
    setIsLoading(true);
    try {
      const body = { user_vehicle_mapping_id: qrcodeId };

      const res = await APIUtility.GetVehicleDetails(body);

      if (res.status == 200) {
        setImageDetails(res.data); // Set state with fetched data
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in fetching QR code details:", error);
      setIsLoading(false);
    }
  };

  const Data = [
    {
      name: "Ownership Details",
      subData: [
        {
          label: "Owner Name",
          value: "Ariana Martin",
        },
        {
          label: "Ownership",
          value: "First Owner",
        },
        {
          label: "Registration Date",
          value: "20 May, 2009",
        },
        {
          label: "Financer’s Name",
          value: "HDFCBANKLTD",
        },
        {
          label: "Registered RTO",
          value: "Nellore RTA, Andhra Pradesh",
        },
      ],
    },
    {
      name: "Vehicle Details",
      subData: [
        {
          label: "Maker Model",
          value: "Ashok Leyland LTD, 2214/18S",
        },
        {
          label: "Vehicle Class",
          value: "Good Carrier (HGV)",
        },
        {
          label: "Fuel Type",
          value: "Diesel",
        },
        {
          label: "Fuel Norms",
          value: "Not Available",
        },
        {
          label: "Engine No. ",
          value: "JNH5XXXXX",
        },
      ],
    },
    {
      name: "Other Info",
      subData: [
        {
          label: "Registration No. ",
          value: "AP26TT1359",
        },
        {
          label: "Color ",
          value: "NP",
        },
        {
          label: "Unloaded Weight (Kg) ",
          value: "8255",
        },
        {
          label: "RC Status ",
          value: "Active",
        },
        {
          label: "Engine No. ",
          value: "JNH5XXXXX",
        },
      ],
    },
    {
      name: "Important Dates",
      subData: [
        {
          label: "Insurance Expiry ",
          value: "Ashok Leyland LTD, 2214/18S",
        },
        {
          label: "Insurance Expiring In ",
          value: "1 Month, 17 Days",
        },
        {
          label: "Vehicle Age ",
          value: "16 Years, 4 Month",
        },
        {
          label: "Fitness Upto ",
          value: "24 July, 2024",
        },
        {
          label: "Registration Date ",
          value: "20 May, 2009",
        },
      ],
    },
    {
      name: "Other Info",
      subData: [
        {
          label: "Registration No. ",
          value: "AP26TT1359",
        },
        {
          label: "Color ",
          value: "NP",
        },
        {
          label: "Unloaded Weight (Kg) ",
          value: "8255",
        },
        {
          label: "RC Status ",
          value: "Active",
        },
        {
          label: "Engine No. ",
          value: "JNH5XXXXX",
        },
      ],
    },
  ];

  const NoDetails = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={NoDataImg} />
      <h3 className=" text-[16px] font-semibold text-[#000] mt-3 text-center">
        Details Not Available
      </h3>
      <p className=" text-[14px] font-normal text-center">
        Details of{" "}
        <span className=" font-semibold">
          {ImageDetails?.vehicle_info_boom_barrier?.license_plate}
        </span>{" "}
        Vehicle No. are not available in MParivan{" "}
      </p>
    </div>
  );
  const mParivahanDataFun = (mparivanData) => {
   
    return [

      { label: "Owner Name", value: mparivanData?.owner_name || "N/A" },
      { label: "Ownership", value: mparivanData?.ownership || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },
      { label: "Financer’s Name", value: mparivanData?.financer_name || "N/A" },
      { label: "Registered RTO", value: mparivanData?.registered_rto || "N/A" },
      { label: "Color", value: mparivanData?.color || "N/A" },
      { label: "Unloaded Weight (Kg)", value: mparivanData?.unloaded_weight || "N/A" },
      { label: "RC Status", value: mparivanData?.rc_status || "N/A" },
      { label: "Maker Model", value: mparivanData?.vehicle_maker_model || "N/A" },
      { label: "Vehicle Class", value: mparivanData?.vehicle_class || "N/A" },
      { label: "Fuel Type", value: mparivanData?.vehicle_fuel_type || "N/A" },
      { label: "Fuel Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
      { label: "Engine No.", value: mparivanData?.vehicle_engine_no || "N/A" },
      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },

      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },
      { label: "Vehicle Age", value: mparivanData?.imp_date_vehicle_age || "N/A" },
      { label: "Fitness Upto", value: mparivanData?.imp_date_fitness_upto || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },

      { label: "Sleeper Capacity", value: mparivanData?.sleeper_capacity || "N/A" },
      { label: "Standing Capacity", value: mparivanData?.standing_capacity || "N/A" },
      { label: "Emission Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
    ]
     
  }




  return (
    <div>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="!p-0">
          <button
            className=" absolute right-[10px] top-[10px] text-black"
            onClick={() => onHide()}
          >
            <X size={26} />
          </button>
          {isLoading ? (
            <div className="flex items-center justify-center h-[60vh]">
              <Loader />
            </div>
          ) : (
            <div className=" flex  h-full w-full">
              <div className=" w-[68%] bg-[#F9F9F7] py-[20px] px-[20px] rounded-s-xl">
                <div className="flex flex-col h-full">
                  <h3 className="flex items-center gap-3 font-bold text-[18px]">
                    <ArrowLeft
                      className=" cursor-pointer"
                      onClick={() => props.onHide()}
                    />{" "}
                    Capture Vehicle No. Plate
                  </h3>
                  <div className="flex items-center justify-between mt-3">
                    <div className="">
                      <h3 className=" text-[18px] font-normal text-black">
                        UUID : <span className=" font-bold">-</span>
                      </h3>
                      <p className=" text-[14px] font-medium italic text-black">
                        <span className="mr-2">{ImageDetails?.date}</span>
                        <span>{ImageDetails?.time}</span>
                      </p>
                    </div>
                    <div className="">
                      <h3 className=" text-[18px] font-normal text-black">
                        Reporting No. : <span className=" font-bold">{ImageDetails?.reporting_no || "-"}</span>
                      </h3>
                      <p className=" text-[14px] font-medium italic text-black text-right">
                        <span className="mr-2">{ImageDetails?.date || "-"}</span>
                        <span>{ImageDetails?.time || "-"}</span>
                      </p>
                    </div>
                  </div>
                  <div className="w-full h-[65vh] flex-grow">
                    {
                      ImageDetails?.vehicle_image_url_main_gate ? <ImageWithRect
                      data={{
                        img: APIEND_POINT + ImageDetails?.vehicle_image_url_main_gate,
                        label: ImageDetails?.vehicle_info_main_gate?.license_plate,
                        ...ImageDetails?.vehicle_info_main_gate,
                      }}
                    />:<img className=" w-full h-full object-cover" src="https://static.vecteezy.com/system/resources/thumbnails/022/014/063/small_2x/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg" />
                    }
    
                  </div>
                </div>
              </div>
              <div className="w-[32%] py-[20px] px-[20px]">
                <div className="">
                  <label className=" text-[13px] font-medium mb-1">
                    Detected Vehicle No.
                  </label>
                  <div className="bg-[#FBFBFB] h-[45px] rounded-[5px] border-[2px] border-black/10 hover:border-[3px] hover:border-[#FEC601] flex items-center px-2">
                    <h2 className="text-[16px] cursor-default font-semibold font-['Roboto'] text-black m-0 flex-grow">
                      {ImageDetails?.vehicle_info_main_gate?.license_plate}
                    </h2>
                    {
                      ImageDetails?.vehicle_info_main_gate?.confidence_score &&  <div className="flex items-center ml-auto gap-2 relative">
                      <div className="bg-[#3da91c2f] cursor-default text-[#3DA91C] font-bold text-[14px] w-[55px] h-[35px] rounded flex items-center justify-center">
                        {`${ImageDetails?.vehicle_info_main_gate?.confidence_score}%`}
                      </div>
                  
                    </div>
                    }
             
                  </div>
                </div>
                <div className="border-b mt-3">
                  <h4 className=" text-[14px] font-medium">Vehcile Details</h4>
                  {/* <p className='text-[13px] font-normal text-black opacity-[0.3] m-0 mb-1'>Data Not Available Yet</p>
                   */}
                  <h3 className=" text-[#21821D] text-[13px] font-medium m-0 mb-1">
                 {ImageDetails?.last_updated}
                  </h3>
                </div>
                <div className="h-screen_h_262 overflow-y-auto hideScrollBar flex w-full">
                  {/* {WaitingLoader} */}
                  {/* {GenerateQr} */}
                  {/* {notFound} */}
                  {/* {notExistInSap} */}
                  {/* {SomethingWrong} */}
             
                  { 
                    ImageDetails?.m_parivan_data && Object.keys(ImageDetails?.m_parivan_data).length>0? <div className="h-full w-full flex flex-col gap-1 bg-[#FAFAFA]">
                    {mParivahanDataFun(ImageDetails?.m_parivan_data).map((each, i) => {
                      return (
  
                        <div
                        key={i}
                        className="flex items-center   w-full"
                      >
                        <div className="flex items-center pl-2 w-1/2 py-2">
                          <p className="m-0 font-normal text-[14px] text-[#000] h-full">
                            {each.label} :
                          </p>
                        </div>
                        <div className="flex items-center pl-2 w-1/2 bg-[#F5F5F5] h-full py-2">
                          <p className="m-0 font-medium text-[14px] text-[#000]">
                            {each.value}
                          </p>
                        </div>
                      </div>
                       
                      );
                    })}
                  </div>:NoDetails
                  }

                  <div className="h-full w-full hidden">
                    {Data.map((item, i) => {
                      return (
                        <div key={i} className="w-full">
                          <h2 className=" font-normal text-[15px] text-[#000] opacity-[0.4] m-0 mt-3 mb-2">
                            {item.name}
                          </h2>
                          <div className="bg-[#FAFAFA] w-full flex flex-col gap-1">
                            {item.subData.map((each, index) => {
                              return (
                                <div
                                  key={index}
                                  className="flex items-center  w-full"
                                >
                                  <div className="flex items-center pl-2 w-1/2 py-2">
                                    <p className="m-0 font-normal text-[14px] text-[#000] h-full">
                                      {each.label} :
                                    </p>
                                  </div>
                                  <div className="flex items-center pl-2 w-1/2 bg-[#F5F5F5] h-full py-2">
                                    <p className="m-0 font-medium text-[14px] text-[#000]">
                                      {each.value}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewImageModal;
